import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

function obtenerOptionsSelect(datos) {
  const array = [];

  if (datos?.length > 13) {
    array.push(10, 25, 40, "Todos");
  } else {
    datos?.forEach((dato, i) => {
      if (i + 1 != datos.length) array.push(i + 1);
    });
    array.push("Todos");
  }

  return array;
}

const PaginationAvantsolar = ({
  data,
  nPages,
  currentPage,
  setCurrentPage,
  recordsPerPage,
  setRecordsPerPage,
  defaultMostrar,
}) => {
  const { huerta } = useSelector((state) => state.dataApp);
  const pageNumbers = [...[nPages + 1].keys()].slice(1);
  const [pageChangeInput, setPageChangeInput] = useState(recordsPerPage);
  const [datosMostrarRegistros, setDatosMostrarRegistros] = useState({
    registroInicial: 0,
    registroFinal: 0,
  });
  const [selectOptions, setSelectOptions] = useState([]);
  const { registroInicial, registroFinal } = datosMostrarRegistros;

  const lastPage = () => setCurrentPage(nPages);
  const firstPage = () => setCurrentPage(1);

  const nextPage = () => {
    if (currentPage !== nPages) setCurrentPage(currentPage + 1);
  };
  const prevPage = () => {
    if (currentPage !== 1) setCurrentPage(currentPage - 1);
  };

  useEffect(() => {
    let dataSelect = obtenerOptionsSelect(data);

    setSelectOptions(dataSelect);
  }, [data]);

  useEffect(() => {
    setCurrentPage(1);
  }, [huerta]);

  const handleChangeSelect = (event) => {
    setPageChangeInput(event.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    let total_registros = data?.length;
    let registros_por_pagina = recordsPerPage;
    let pagina_actual = currentPage;
    let limite_inferior = (pagina_actual - 1) * registros_por_pagina + 1;
    let limite_superior = Math.min(
      pagina_actual * registros_por_pagina,
      total_registros
    );

    setDatosMostrarRegistros({
      registroInicial: limite_inferior,
      registroFinal: limite_superior,
    });
  }, [data, recordsPerPage, currentPage]);

  useEffect(() => {
    setRecordsPerPage(pageChangeInput);
    scrollToTop();
  }, [pageChangeInput]);

  return (
    <>
      {data?.length > 0 && (
        <div className="d-flex align-items-center mt-3 px-2 ">
          <div className="d-flex  justify-content-between paginacion w-100">
            <div className="page-item d-flex flex-column w-50">
              <div className="d-flex align-items-center">
                <p className="mx-1">Mostrar:</p>
                <select
                  onChange={(event) => {
                    handleChangeSelect(event);
                  }}
                  className={`p-1 ml-1`}
                >
                  {selectOptions?.map((option, i) => {
                    if (option == "Todos" && defaultMostrar == "Todos") {
                      return (
                        <option selected key={i} value={data?.length}>
                          {option}
                        </option>
                      );
                    } else if (option == defaultMostrar) {
                      return (
                        <option selected key={i} value={option}>
                          {option}
                        </option>
                      );
                    } else if (option == "Todos") {
                      return (
                        <option key={i} value={data?.length}>
                          {option}
                        </option>
                      );
                    } else {
                      return (
                        <option key={i} value={option}>
                          {option}
                        </option>
                      );
                    }
                  })}
                </select>
                <p className="mx-1">registros</p>
              </div>
              <p className="ml-1  ">
                Mostrando registros del{" "}
                <span className="font-weight-bold">
                  {registroInicial && registroInicial}
                </span>{" "}
                al{" "}
                <span className="font-weight-bold">
                  {registroFinal && registroFinal}
                </span>{" "}
                de {data?.length}
              </p>
            </div>

            <ul className="pagination justify-content-center mr-2  mt-2">
              <li className="page-item d-flex justify-content-end align-items-center"></li>
              <li className="page-item">
                <small
                  className={`pageLinkAvant ${
                    currentPage === 1 ? "disabled" : ""
                  }`}
                  onClick={currentPage === 1 ? null : firstPage}
                >
                  <span className="material-icons">1</span>
                </small>
              </li>
              <li className="page-item">
                <small
                  className={`pageLinkAvant ${
                    currentPage === 1 ? "disabled" : ""
                  }`}
                  onClick={currentPage === 1 ? null : prevPage}
                >
                  <span className="mdi mdi-chevron-double-left">{""}</span>
                </small>
              </li>
              <li className="page-item">
                <small
                  className={`pageLinkAvant ${
                    currentPage === nPages ? "disabled" : ""
                  }`}
                >
                  <span>{currentPage}</span>
                </small>
              </li>
              <li className="page-item">
                <small
                  className={`pageLinkAvant ${
                    currentPage === nPages ? "disabled" : ""
                  }`}
                  onClick={currentPage === nPages ? null : nextPage}
                >
                  <span className="mdi mdi-chevron-double-right">{""}</span>
                </small>
              </li>
              <li className="page-item">
                <small
                  className={`pageLinkAvant ${
                    currentPage === nPages ? "disabled" : ""
                  }`}
                  onClick={currentPage === nPages ? null : lastPage}
                >
                  <span className="">{nPages}</span>
                </small>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default PaginationAvantsolar;
